/**
 * Expandable Cards Section - Pure Tailwind Version
 * Enhanced animations and functionality without slider
 */

(function () {
  "use strict";

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  function init() {
    // Check if section exists
    const sections = document.querySelectorAll(".expandable-cards-section");

    if (sections.length === 0) {
      return;
    }

    initScrollAnimations();
    initExpandableCards();
  }

  function initScrollAnimations() {
    // Trigger animations when section comes into view
    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              const section = entry.target;

              // Trigger fade animations
              const fadeUpElements = section.querySelectorAll(
                ".expandable-animate-fade-up"
              );
              fadeUpElements.forEach(function (el) {
                el.style.animationPlayState = "running";
              });

              // Observer can be disconnected once animations are triggered
              observer.unobserve(section);
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: "50px",
        }
      );

      const sections = document.querySelectorAll(".expandable-cards-section");
      sections.forEach(function (section) {
        observer.observe(section);
      });
    }
  }

  // Add CSS styles for animations and proper card sizing
  const style = document.createElement("style");
  style.textContent = `
    /* Animation keyframes */
    @keyframes expandable-fadeInUp {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    
    /* Apply to elements with class */
    .expandable-animate-fade-up {
      animation: expandable-fadeInUp 0.8s ease-out forwards;
      animation-play-state: paused; /* Start paused, triggered by JS */
    }
    
    /* Enhanced card styling for expandable functionality */
    .expandable-cards-section .cards-container {
      scroll-padding: 1rem;
      -webkit-overflow-scrolling: touch;
    }
    
    .expandable-cards-section .card-item {
      transition: all 0.7s ease-in-out;
      cursor: pointer;
    }
    
    .expandable-cards-section .card-item .expandable-content {
      max-height: 0;
      opacity: 0;
      overflow: hidden;
      transition: all 0.5s ease-in-out;
    }
    
    .expandable-cards-section .card-item.card-expanded .expandable-content {
      max-height: 250px;
      opacity: 1;
    }
    
    @media (max-width: 767px) {
      .expandable-cards-section .card-item.card-expanded .expandable-content {
        max-height: 300px;
      }
    }
    
    .expandable-cards-section .card-item .expand-icon {
      transform: rotate(0deg);
      transition: all 0.3s ease;
      color: white;
    }
    
    .expandable-cards-section .card-item .collapse-icon {
      transform: rotate(0deg);
      transition: all 0.3s ease;
      opacity: 0;
      color: white;
    }
    
    .expandable-cards-section .card-item.card-expanded .expand-icon {
      opacity: 0;
      transform: rotate(180deg);
    }
    
    .expandable-cards-section .card-item.card-expanded .collapse-icon {
      opacity: 1;
      transform: rotate(0deg);
    }
    
    /* Card size controls with updated dimensions */
    .expandable-cards-section .card-collapsed {
      width: 400px;
      min-width: 280px;
      max-width: 453px;
      flex-shrink: 0;
    }
    
    .expandable-cards-section .card-expanded {
      width: 400px;
      min-width: 280px;
      max-width: 800px;
      flex-shrink: 0;
      z-index: 10;
    }
    
    .expandable-cards-section .cards-container {
      display: flex;
      gap: 16px;
    }
    
    .expandable-cards-section .cards-wrapper {
      overflow-x: auto;
      width: 100%;
      scroll-behavior: smooth;
    }
    
    /* Desktop: horizontal scroll layout */
    @media (min-width: 768px) {
      .expandable-cards-section .card-collapsed {
        width: 375px;
      }
      
      .expandable-cards-section .card-expanded {
        width: 735px;
      }
      
      .expandable-cards-section .cards-container {
        display: flex;
        flex-direction: row;
      }
      
      .expandable-cards-section .cards-wrapper {
        overflow-x: auto;
      }
    }
    
    /* Mobile: vertical stack layout */
    @media (max-width: 767px) {
      .expandable-cards-section .cards-container {
        display: flex;
        flex-direction: column;
        gap: 16px;
      }
      
      .expandable-cards-section .cards-wrapper {
        overflow-x: visible;
        overflow-y: visible;
      }
      
      .expandable-cards-section .card-collapsed,
      .expandable-cards-section .card-expanded {
        width: 100%;
        max-width: 100%;
        min-width: 100%;
      }
      
      .expandable-cards-section .card-item {
        width: 100% !important;
      }
    }
    
    .expandable-cards-section .card-wrapper {
      height: 538px !important;
      min-height: 538px !important;
    }
    
    /* Keep same height on mobile - image stays large */
    @media (max-width: 767px) {
      .expandable-cards-section .card-wrapper {
        height: 538px !important;
        min-height: 538px !important;
      }
      
      .expandable-cards-section .card-item.card-expanded .card-wrapper {
        height: 538px !important;
        min-height: 538px !important;
      }
    }
    
    /* Ensure card wrapper maintains fixed height when expanded */
    .expandable-cards-section .card-item.card-expanded .card-wrapper {
      height: 538px !important;
      min-height: 538px !important;
    }
    
    /* Hover effects */
    .expandable-cards-section .expand-btn:hover {
      opacity: 0.8;
    }
  `;
  document.head.appendChild(style);

  function initExpandableCards() {
    const sections = document.querySelectorAll(".expandable-cards-section");

    sections.forEach(function (section) {
      const cards = section.querySelectorAll(".card-item");
      const cardsWrapper = section.querySelector(".cards-wrapper");

      // Expand the first card by default
      let firstCardExpanded = false;
      
      cards.forEach(function (card, cardIndex) {
        const expandBtn = card.querySelector(".expand-btn");
        
        // Make the first card expanded by default
        if (cardIndex === 0 && !firstCardExpanded) {
          expandCard(card);
          // Center the expanded card
          setTimeout(() => {
            scrollToCard(section, card);
          }, 100);
          firstCardExpanded = true;
        }

        if (expandBtn) {
          expandBtn.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();

            const cardItem = this.closest(".card-item");
            const expandableContent = cardItem.querySelector(
              ".expandable-content"
            );

            const isExpanded = cardItem.classList.contains("card-expanded");

            if (!isExpanded) {
              // Collapse any other expanded cards in this section
              const otherExpandedCards = section.querySelectorAll(
                ".card-item.card-expanded"
              );
              otherExpandedCards.forEach(function (otherCard) {
                if (otherCard !== cardItem) {
                  collapseCard(otherCard);
                }
              });

              // Expand this card
              expandCard(cardItem);

              // Scroll to the expanded card
              scrollToCard(section, cardItem);
            } else {
              // Collapse this card
              collapseCard(cardItem);
            }
          });
        }
        
        // Make entire card clickable
        card.addEventListener("click", function(e) {
          // Ignore clicks on buttons and links
          if (e.target && (e.target.closest('a') || e.target.closest('button'))) {
            return;
          }
          
          const expandBtn = this.querySelector(".expand-btn");
          if (expandBtn) {
            expandBtn.click();
          }
        });
      });
    });
  }

  function scrollToCard(section, cardItem) {
    // Skip scrolling on mobile (cards are stacked vertically)
    if (window.innerWidth < 768) {
      return;
    }
    
    const cardsWrapper = section.querySelector(".cards-wrapper");
    if (!cardsWrapper) return;
    
    const cardRect = cardItem.getBoundingClientRect();
    const containerRect = cardsWrapper.getBoundingClientRect();
    
    // Calculate the scroll position to center the card in the wrapper
    const scrollLeft = (cardItem.offsetLeft + (cardRect.width / 2)) - (containerRect.width / 2);
    
    // Use scrollTo to smoothly scroll to the expanded card
    cardsWrapper.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  }

  function expandCard(cardItem) {
    cardItem.classList.remove("card-collapsed");
    cardItem.classList.add("card-expanded");

    const expandableContent = cardItem.querySelector(".expandable-content");
    if (expandableContent) {
      // Force a reflow to ensure the transition works
      expandableContent.style.display = "block";
      expandableContent.getBoundingClientRect();

      setTimeout(function () {
        // Use larger max-height on mobile
        const maxHeight = window.innerWidth < 768 ? "300px" : "250px";
        expandableContent.style.maxHeight = maxHeight;
        expandableContent.style.opacity = "1";
      }, 50);
    }

    // Add expanded state visual feedback
    const expandBtn = cardItem.querySelector(".expand-btn");
    if (expandBtn) {
      expandBtn.style.transform = "scale(1.1)";
    }
  }

  function collapseCard(cardItem) {
    cardItem.classList.remove("card-expanded");
    cardItem.classList.add("card-collapsed");

    const expandableContent = cardItem.querySelector(".expandable-content");
    if (expandableContent) {
      expandableContent.style.maxHeight = "0";
      expandableContent.style.opacity = "0";
    }

    // Reset expand button
    const expandBtn = cardItem.querySelector(".expand-btn");
    if (expandBtn) {
      expandBtn.style.transform = "scale(1)";
    }
  }

  function initCarousel() {
    const sections = document.querySelectorAll(".expandable-cards-section");

    sections.forEach(function (section) {
      const cardsWrapper = section.querySelector(".cards-wrapper");
      const cardsContainer = section.querySelector(".cards-container");
      const cards = section.querySelectorAll(".card-item");
      const prevBtn = section.querySelector(".nav-prev");
      const nextBtn = section.querySelector(".nav-next");
      const dotsContainer = section.querySelector(".flex.gap-2"); // The dots container div

      if (!cardsContainer || cards.length === 0) {
        return;
      }

      let currentSlide = 0;

      // Calculate cards per view based on actual dimensions
      function calculateCardsPerView() {
        const containerWidth = cardsWrapper.offsetWidth;
        // Use widths based on screen size
        let cardWidth = window.innerWidth < 768 ? 280 : 400;
        const gap = 16; // gap between cards (gap-4 = 16px)
        const cardsPerView = Math.floor(containerWidth / (cardWidth + gap));
        return Math.max(1, cardsPerView);
      }

      let cardsPerView = calculateCardsPerView();
      let maxSlides = Math.max(0, cards.length - cardsPerView);
      let isTransitioning = false;

      // Initialize all cards as collapsed with specific dimensions
      cards.forEach(function (card, index) {
        card.classList.add("card-collapsed");
        
        // Make the first card expanded by default
        if (index === 1) {
          expandCard(card);
          // Center the expanded card
          setTimeout(() => {
            scrollToCard(section, card);
          }, 100);
        }
      });

      // Work with existing dots instead of creating new ones
      const existingDots = dotsContainer
        ? dotsContainer.querySelectorAll(".dot")
        : [];

      // Add click event listeners to existing dots
      existingDots.forEach(function (dot, index) {
        // Make the first dot active by default
        if (index === 0) {
          dot.className = "w-3 h-3 transition-all duration-300 scale-125 bg-blue-500 rounded-full dot hover:scale-125";
        }
        
        dot.addEventListener("click", function () {
          goToSlide(index);
        });
      });

      // Only create dots if none exist and we need sliding
      if (
        !existingDots.length &&
        dotsContainer &&
        cards.length > cardsPerView
      ) {
        // Create dots for each slide position
        for (let i = 0; i <= maxSlides; i++) {
          const dot = document.createElement("button");
          dot.className = `dot w-3 h-3 rounded-full transition-all duration-300 hover:scale-125`;
          if (i === 0) {
            dot.classList.add("bg-blue-500", "scale-125");
          } else {
            dot.classList.add("bg-gray-400");
          }
          dot.setAttribute("data-slide", i.toString());

          dot.addEventListener("click", function () {
            goToSlide(i);
          });

          dotsContainer.appendChild(dot);
        }
      }

      function goToSlide(slideIndex) {
        if (slideIndex < 0 || slideIndex > maxSlides || isTransitioning) {
          return;
        }

        isTransitioning = true;
        currentSlide = slideIndex;

        // Calculate slide width based on actual card width
        let cardWidth = window.innerWidth < 768 ? 280 : 400; // Default based on screen size
        if (cards.length > 0) {
          const firstCard = cards[0];
          cardWidth = firstCard.offsetWidth || cardWidth;
        }
        const gap = 16;
        const slideWidth = cardWidth + gap;
        const translateX = -(currentSlide * slideWidth);

        cardsContainer.style.transform = `translateX(${translateX}px)`;

        // Update dots
        const allDots = dotsContainer.querySelectorAll(".dot");
        allDots.forEach(function (dot, index) {
          if (index === currentSlide) {
            dot.className =
              "w-3 h-3 transition-all duration-300 scale-125 bg-blue-500 rounded-full dot hover:scale-125";
          } else {
            dot.className =
              "w-3 h-3 transition-all duration-300 bg-gray-400 rounded-full dot hover:scale-125";
          }
        });

        // Update nav buttons
        if (prevBtn) {
          prevBtn.disabled = currentSlide === 0;
          if (currentSlide === 0) {
            prevBtn.style.opacity = "0.5";
          } else {
            prevBtn.style.opacity = "1";
          }
        }

        if (nextBtn) {
          nextBtn.disabled = currentSlide >= maxSlides;
          if (currentSlide >= maxSlides) {
            nextBtn.style.opacity = "0.5";
          } else {
            nextBtn.style.opacity = "1";
          }
        }

        // Reset transition flag after animation
        setTimeout(function () {
          isTransitioning = false;
        }, 500);
      }

      // Handle mobile scroll
      let touchStartX = 0;
      let touchEndX = 0;
      
      cardsWrapper.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      
      cardsWrapper.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      }, { passive: true });
      
      function handleSwipe() {
        const swipeThreshold = 50;
        if (touchEndX < touchStartX - swipeThreshold) {
          // Swipe left - next slide
          if (currentSlide < maxSlides) {
            goToSlide(currentSlide + 1);
          }
        } else if (touchEndX > touchStartX + swipeThreshold) {
          // Swipe right - previous slide
          if (currentSlide > 0) {
            goToSlide(currentSlide - 1);
          }
        }
      }

      // Disable navigation if no sliding needed
      if (cards.length <= cardsPerView) {
        if (prevBtn) {
          prevBtn.style.opacity = "0.3";
          prevBtn.disabled = true;
        }
        if (nextBtn) {
          nextBtn.style.opacity = "0.3";
          nextBtn.disabled = true;
        }
        return;
      }

      // Navigation event listeners
      if (prevBtn) {
        prevBtn.addEventListener("click", function () {
          goToSlide(currentSlide - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener("click", function () {
          goToSlide(currentSlide + 1);
        });
      }

      // Window resize handler
      window.addEventListener("resize", function () {
        const newCardsPerView = calculateCardsPerView();
        if (newCardsPerView !== cardsPerView) {
          cardsPerView = newCardsPerView;
          maxSlides = Math.max(0, cards.length - cardsPerView);

          // Reset to first slide
          currentSlide = 0;
          goToSlide(0);
        }
      });
    });
  }
})();
